module.exports = __webpack_public_path__ + "static/media/A1_Skiing_BG.2ff8855d.png";